import React, { Component } from 'react'
import { Grid, Header, Image, Loader, Message, Segment } from 'semantic-ui-react'
import { observer } from 'mobx-react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import AuthenticationStore from '../stores/AuthenticationStore'

@withRouter
@observer
class ClientsLoginScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    history: PropTypes.object,
    match: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (!props.match.params.uuid) {
      props.history.push('/')
    }
  }

  componentDidMount () {
    const { authenticationStore, match } = this.props
    authenticationStore.clientLogin(match.params.uuid).then((response) => {
      if (response.success && ['PUSH'].includes(this.props.history.action)) {
        this.props.history.goBack()
      }
    })
  }

  render () {
    const { errorMessage } = this.props.authenticationStore
    return (
      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
        <Grid.Column style={{ maxWidth: 450 }}>
          <Segment>
            <Image src='/img/mci/mci_logo_new.png' size='large' />
            <Header as='h2' className='primary-blue' textAlign='center'>
              Connexion à votre compte client
            </Header>

            {!errorMessage && <Loader inline='centered' active />}
            {!!errorMessage &&
              <Message negative>
                <p>{errorMessage}</p>
              </Message>}
          </Segment>

        </Grid.Column>
      </Grid>
    )
  }
}

export default ClientsLoginScreen
